import {SecurityRequestBase} from '@/oauth/SecurityRequestBase';
import {User} from '@/oauth/User';
import {Pagination} from '@/oauth/Pagination';
import {Page} from '@/oauth/Page';
import {RemoveEmptyUtils} from "pansx-utils/src/index";
import {Base} from "@/dto/Base";


export class UserDto {
    private static url = '/api/v1/user';

    public static async save(u: User): Promise<User> {
        try {
            const response = await SecurityRequestBase.postWithToken(this.url + '/save', u);
            const user = await response as User;
            return User.of(user);
        } catch (e) {
            throw Error('错误:' + e);
        }
    }

    public static async login(u: User) {
        const response = await SecurityRequestBase.post(SecurityRequestBase.getUrl() + this.url + '/login?username=' +
            u.username + '&password=' + u.password);
        const user = await response.data as User;
        return User.of(user);
    }

    public static async findByUsername(username: string): Promise<User> {
        const response = await SecurityRequestBase.getDataWithJwt(this.url + '/byUsername', {username});
        const page = response as User;
        return User.of(page);
    }

    public static async findById(id: number): Promise<User> {
        const response = await SecurityRequestBase.getDataWithJwt(this.url + '/byId', {id});
        const page = response as User;
        return User.of(page);
    }

    public static async getAll(p: Pagination, filter?: any): Promise<Page<User>> {
        const data = await SecurityRequestBase.findAllPageWithToken<User>(this.url + '/all', p, filter);
        return data;
    }

    public static async getAllByDate(size: number, page: number, date: { date: string }): Promise<Page<User>> {
        const data = await SecurityRequestBase.getData(this.url + `/date/${size}/${page - 1}`, date);
        const userPage = await data as Page<User>;
        return userPage;
    }

    public static async findAllByAuthority(authority: string): Promise<User[]> {
        const data = await SecurityRequestBase.getDataWithJwt(this.url + `/findAllByAuthority`, {authority});
        const userPage = data as User[];
        return userPage;
    }

    static async delete(id: number) {
        const data = await SecurityRequestBase.getDataWithJwt(this.url + `/delete/${id}`);
        return await data as boolean;

    }

    public static async findAll(user: User): Promise<User[]> {
        RemoveEmptyUtils.removeEmptyString(user);
        RemoveEmptyUtils.removeZero(user);
        const response = await Base.getDataWithJwt<User[]>(
            this.url + '/all',
            user,
        );
        const userList = response as User[];
        return userList;
    }

    static async findByUsername1(username: string): Promise<boolean> {
        return await SecurityRequestBase.getData(this.url + '/byUsername', {username}) as boolean;
    }

    static async findUser(username: string): Promise<User> {
        const response = await SecurityRequestBase.getData(this.url + '/byUsername', {username})
        const user = response as User
        return User.of(user)
    }

    static async logOff(username: string) {
        const response = await SecurityRequestBase.postWithToken("/api/uie/logOff?userName=" + username, {username})
        return response
    }


    //  static  async  saveCompany(collectionCompany: string): Promise<User>{
    //     const  response = await  SecurityRequestBase.getDataWithJwt(this.url+'/saveCompany',{collectionCompany});
    //     const  userCompany =response as User
    //     return  User.of(userCompany);
    // }


}

